import React from 'react';
import { Heading, Text } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';

interface IdentificationFormHeaderProps {
    title: string;
    subTitle: React.ReactNode;
}

export const IdentificationFormHeader = ({ title, subTitle }: IdentificationFormHeaderProps) => (
    <Container>
        {title && (
            <Heading as="h4" marginBottom="2">
                {title}
            </Heading>
        )}
        {subTitle && (
            <Text as="span" color="bodySecondary">
                {subTitle}
            </Text>
        )}
    </Container>
);
